import React, { useContext, useEffect } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity'
import FilterWrapper from './FilterWrapper';

/**
 * The SectorFilter function is a component that renders a filter for selecting sectors,
 * with options that can be checked or unchecked.
 * @returns The SectorFilter component is returning a JSX element.
 */
function SectorFilter({ open, accordionClick, SectorOptions, setSectorOptions, customPathname, label }) {

    const { Sectors, setSectors, refineSearchFilters } = useContext(PeFilterContext);

    useEffect(() => {
        const ids = refineSearchFilters[customPathname]?.sector?.map(value => value.id) ?? [];
        setSectorOptions(Sectors?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
    }, [Sectors, customPathname, refineSearchFilters, setSectorOptions])


    const handleSectorChange = ((e) => {
        const { name, checked, id } = e.target;
        if (name === "allSelect") {
            let currentSectors = SectorOptions.map((sector) =>
                ({ ...sector, isChecked: checked })
            );
            setSectorOptions(currentSectors);
        } else {
            let currentSectors = SectorOptions.map((sector) =>
                sector.id == parseInt(id) ? { ...sector, isChecked: checked } : sector
            );
            setSectorOptions(currentSectors);
        }
    });

    const selectedSectorLength = SectorOptions?.filter(option => option.isChecked)?.length ?? 0
    return (
        <div className="border-b-[3px] border-[#E8E6E1]">
            <li
                className={
                    open
                        ? "bg-white relative px-3 py-1"
                        : "relative px-3 py-1"
                }
            >
                <FilterWrapper
                    count={selectedSectorLength}
                    isSelect={false}
                    label={label ? label : "Sector"}
                    onClick={accordionClick}
                    open={open}
                />
                <div
                    className="relative overflow-hidden transition-all max-h-0 duration-700  overflow-y-auto no-scrollbar"
                    style={{ maxHeight: open ? "10rem" : "" }}
                >
                    {open === true ? <MultiSelectEntity
                        handleEntityChange={handleSectorChange}
                        primaryEntity={SectorOptions}
                        showAll={false}
                        field="sector"
                    /> : <></>}

                </div>
            </li>
        </div>
    )
}

export default SectorFilter